import { useEffect, useMemo, useState } from "react";
/**
 * Use the `?email-confirmation-token=` parameter and confirm the new email of an user.
 */ function useAccountEmailConfirmationToken(updater) {
    const params = useMemo(()=>new URLSearchParams(window.location.search), []);
    const [emailConfirmationToken, setEmailConfirmationToken] = useState(params.get("email-confirmation-token") || undefined);
    // Listen to `?email-confirmation-token=`
    useEffect(()=>{
        if (emailConfirmationToken) {
            const post = async ()=>{
                // Replace current URL without GET parameter
                const newUrl = window.location.href.replace(/([?]?email-confirmation-token=\w{8}-\w{4}-\w{4}-\w{4}-\w{12}[&]?)/gm, "");
                window.history.replaceState({}, document.title, newUrl);
                try {
                    await updater(emailConfirmationToken);
                } finally{
                    // Always reset token so the UI can be updated
                    setEmailConfirmationToken(undefined);
                }
            };
            post();
        }
    }, []);
    return {
        emailConfirmationToken
    };
}
export { useAccountEmailConfirmationToken };
